import React from 'react';
import { formatLabel } from '../../../customers/components/reportTable';

export default function SaleByProductTableBodyComponent({
	data,
	params,
	periods,
	selectedColumnsList,
}) {
	return data.flatMap((item, customerIndex) => {
		const ItemRow = (
			<tr key={`customer-${customerIndex}`}>
				<td className="name-col fw-bold">{item[params.group_by]}</td>

				{periods.map((p, i) => {
					const key = formatLabel(p.label);
					const metrics = item.metrics[key] || {};

					return selectedColumnsList.map((m, idx) => (
						<td key={`item-${i}-${idx}`}>{metrics[m.key] ?? 0}</td>
					));
				})}
			</tr>
		);

		const productRows =
			item.products && item.products.length > 0
				? item.products.map((product, productIndex) => (
						<tr key={`product-${customerIndex}-${productIndex}`}>
							<td
								className="name-col"
								style={{ paddingLeft: '30px' }}
							>
								{product.product_name} ({product.product_code})
							</td>

							{periods.map((p, i) => {
								const key = formatLabel(p.label);
								const metrics = product.metrics[key] || {};

								return selectedColumnsList.map((m, idx) => (
									<td key={`product-${i}-${idx}`}>{metrics[m.key] ?? 0}</td>
								));
							})}
						</tr>
					))
				: [];

		return [ItemRow, ...productRows];
	});
}
